import { apiErrorsZh } from './apiErrors'

export default {
  apiErrors: apiErrorsZh,
  common: {
    required: "此项为必填项",
    confirmTitle: "系统提示",
    reminder: '提示',
    loginOutMessage: '确认退出吗?',
    back: '返回',
    ok: '确认',
    save: '保存',
    cancel: '取消',
    close: '关闭',
    deleteUserConfirm: '确定要删除用户 "{userName}" 吗？此操作不可恢复。',
    deleteUserTitle: '删除确认',
    thisUser: '该用户',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    firmwareDeleteApprovalSubmitted: '删除申请已提交成功。该固件将在审批通过后删除。',
    next: '下一步',
    decline: '拒绝'
  },
  sys: {
    api: {
      errMsg500: "服务器内部错误",
      errMsg901: "演示模式，不允许写操作",
      errMsg901Hint: "如需写操作，请搭建本地环境。",
      errorMessage: "网络错误",
      apiTimeoutMessage: "接口请求超时",
      apiRequestFailed: "请求失败",
      timeoutMessage: "登录状态已过期，您可以继续留在该页面，或者重新登录",
      responseDecryptFailed: "响应数据解密失败"
    },
    ui: {
      browserFullscreenUnsupported: "当前浏览器不支持全屏",
      themeResetSuccess: "主题颜色已重置为 {color}",
      invalidHex: "输入错误的 hex 值",
      invalidRgb: "输入错误的 rgb 颜色值",
      invalidHexColor: "输入错误的 hex 颜色值",
      logoutSuccess: "退出登录成功"
    }
  },
  home: {
    welcome: "欢迎使用"
  },
  tabs: {
    refresh: "刷新",
    maximize: "最大化",
    closeCurrent: "关闭当前",
    closeLeft: "关闭左侧",
    closeRight: "关闭右侧",
    closeOther: "关闭其它",
    closeAll: "关闭所有"
  },
  header: {
    componentSize: "组件大小",
    language: "国际化",
    theme: "全局主题",
    layoutConfig: "布局设置",
    primary: "primary",
    darkMode: "暗黑模式",
    greyMode: "灰色模式",
    weakMode: "色弱模式",
    fullScreen: "全屏",
    exitFullScreen: "退出全屏",
    personalData: "个人信息",
    changePassword: "修改密码",
    logout: "退出登录",
    version: "版本",
    userName: "用户名",
    email: "邮箱",
    settings: "设置",
    otherFunction: "其他功能",
    role: "角色"
  },
  login: {
    welcome: '欢迎使用本系统',
    message: '开箱即用的中后台管理系统',
    tenantname: '租户名称',
    username: '用户名',
    password: '密码',
    code: '验证码',
    login: '登录',
    relogin: '重新登录',
    otherLogin: '其他登录方式',
    register: '注册',
    checkPassword: '确认密码',
    remember: '记住我',
    hasUser: '已有账号？去登录',
    forgetPassword: '忘记密码?',
    tenantNamePlaceholder: '请输入租户名称',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    codePlaceholder: '请输入验证码',
    mobileTitle: '手机登录',
    mobileNumber: '手机号码',
    mobileNumberPlaceholder: '请输入手机号码',
    getSmsCode: '获取验证码',
    btnMobile: '手机登录',
    btnQRCode: '二维码登录',
    qrcode: '扫描二维码登录',
    btnRegister: '注册',
    SmsSendMsg: '验证码已发送',
    resetPassword: '重置密码',
    resetPasswordSuccess: '重置密码成功',
    invalidTenantName: '无效的租户名称',
    loadingSystem: '正在加载系统中...',
    containerNotExists: 'Container 不存在',
    captchaError: '验证码错误',
    emailExists: '该邮箱已存在',
    sendingCode: '正在发送验证码...',
    createId: '创建新账号',
    forgotIdOrPassword: '忘记账号或密码？',
    enterUsername: '请输入用户名',
    enterPassword: '请输入密码',
    signIn: '登录',
    setupAccount: '创建账号',
    alreadyHaveAccount: '已有账号？',
    signInLink: '去登录',
    emailAddress: '邮箱地址 *',
    firstName: '名字 *',
    lastName: '姓氏 *',
    countryRegion: '国家 / 地区 *',
    stateProvince: '省 / 州',
    streetAddress: '街道地址',
    city: '城市',
    zipCode: '邮编',
    mobilePhone: 'Tele',
    containerId: 'Company ID *',
    createPassword: '密码',
    byCreatingAccount: '点击创建账号即表示我同意：',
    termsAgreement: '我已阅读并接受《使用条款》。',
    marketingAgreement: 'V-IoT Software 可以通过个性化邮件向我告知产品和服务信息。',
    privacyAgreement: '更多详情或随时取消订阅，请查看《隐私政策》。',
    createAccount: '创建账号',
    verifyAccount: '验证账号',
    verifyAccountHint: '我们将发送一次性验证码到您的邮箱以完成验证。',
    afterSeconds: '{seconds} 秒后',
    resendCode: '重新发送验证码。',
    accountVerified: '太好了！您的账号已验证成功！',
    termsTitle: '使用条款',
    enterEmailAddress: '请输入您的邮箱地址',
    verifyOwnershipHint: '请完成以下信息以验证该账号属于您。',
    email: '邮箱',
    recoveryEmail: '找回邮箱',
    recoveryEmailHint: '我们将向 {email} 发送一封包含一次性验证码的邮件',
    resetPasswordTitle: '重置密码',
    resetPasswordCodeHint: '请输入我们发送到您邮箱的验证码。',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    enterPasswordPlaceholder: '请输入密码',
    passwordsDoNotMatch: '两次输入的密码不一致',
    changePasswordSummary: '您将为以下账号修改密码：{email}',
    signOutOtherSessions: '退出除当前会话外的所有登录。',
    changePassword: '修改密码',
    backLogin: '返回登录',
    resetAction: 'Reset',
    resetPasswordSuccessMessage: 'The new password had been set sucessfully!',
    sendEmailFailed: '发送邮件失败',
    updatePasswordFailed: '修改密码失败',
    emailIncorrectOrNotRegistered: '邮箱错误或尚未注册',
    loginFailedGeneric: '登录失败，请检查邮箱和密码。',
    privacyPolicyLink: '打开隐私政策',
    privacyPolicyNotConfigured: '隐私政策尚未配置。',
    setupEmailNotRegistered: '该邮箱尚未注册，无法继续创建账号。',
    setupEmailAlreadyRegistered: '该邮箱已注册。',
    setupEmailAvailable: '该邮箱可以使用。',
    emailRequired: '邮箱为必填项',
    invalidEmail: '邮箱格式不正确',
    fieldRequired: '此项为必填项',
    passwordRequired: '密码为必填项',
    invalidPassword: '密码长度需为 4-16 位',
    setupPasswordValidation:
      'Password must contain at least one number, one lowercase letter, one uppercase letter, and one special character (e.g. !@#$%^&*()_,.;), and be 8-20 characters long',
    maxCharacters: '最多 {count} 个字符',
    validationCodeError: '验证码错误',
    passwordValidation: 'Password must be 4-16 characters long',
    terms: {
      heading: '使用条款',
      section1Title: '1. 条款接受',
      section1Body: '访问和使用本网站即表示您同意遵守以下条款和条件。如果您不同意这些条款，请不要使用本网站。',
      section2Title: '2. 条款变更',
      section2Body: '我们保留随时修改这些条款的权利。您在变更后继续使用本网站即表示您接受新的条款。',
      section3Title: '3. 网站使用',
      section3Body1: '您必须年满 18 周岁才能使用本网站。',
      section3Body2: '您同意仅将本网站用于合法用途。',
      section3Body3: '您不得以任何可能导致网站或其访问中断、损坏或受损的方式使用本网站。',
      section4Title: '4. 账号注册',
      section4Body1: '创建账号时，您必须提供准确且完整的信息。',
      section4Body2: '您有责任维护账号信息的保密性。',
      section4Body3: '若发现账号被未经授权使用，您必须立即通知我们。',
      section5Title: '5. 隐私政策',
      section5Body: '您对本网站的使用也受我们的隐私政策约束，具体内容可在此查看。',
      section6Title: '6. 知识产权',
      section6Body: '本网站上的所有内容，包括文本、图形、标识和图片，均归网站所有者所有，并受知识产权法律保护。未经明确书面许可，您不得复制、分发或基于任何内容创建衍生作品。',
      section7Title: '7. 责任限制',
      section7Body: '本网站及其内容按“现状”提供。我们不对本网站作出任何明示或暗示的保证。对于因使用或无法使用本网站而产生的任何损失，我们概不负责。',
      section8Title: '8. 终止',
      section8Body: '我们保留自行决定终止您访问本网站的权利，恕不另行通知，也不承担任何责任。',
      section9Title: '9. 适用法律',
      section9Body: '这些条款受 [Your Country/State] 法律管辖并据其解释，不考虑其法律冲突原则。',
      section10Title: '10. 联系方式',
      section10Body: '如果您对本使用条款有任何疑问，请通过 [contact information] 与我们联系。'
    }
  }
};
